/**
 * Compact key-details bar (address+unit · verified · type · status · price) shown atop the
 * analysis page and the standalone listing detail page. Pure presentational.
 *
 * Props:
 *   property - { address, unit_number, verified, building_type, condo_coop, listing_url,
 *               streeteasy_url, listing_status, price/asking_price, price_change, price_change_pct }
 *   onEdit   - optional () => void for the edit pencil
 */
export default function ListingHeaderBar({ property, onEdit }) {
  if (!property) return null;
  const typeLabel = property.building_type || property.condo_coop;
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px",
                  background: "#fff", border: "1px solid #000", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
        {onEdit && (
          <span onClick={onEdit} title="Edit listing"
            style={{ cursor: "pointer", fontSize: "16px", opacity: 0.5, lineHeight: 1, display: "flex", alignItems: "center" }}>&#9998;</span>
        )}
        <span style={{ fontSize: "20px", fontWeight: 700, color: "#111" }}>
          {property.address}{property.unit_number ? `, ${property.unit_number}` : ""}
        </span>
        {property.verified && (
          <span title="Data verified" style={{ fontSize: "11px", fontWeight: 700, color: "#2e7d32",
                         background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: "4px", padding: "2px 8px" }}>
            ✓ Verified
          </span>
        )}
        {typeLabel && (
          <span style={{ fontSize: "12px", fontWeight: 600, color: "#555", border: "1px solid #ddd", borderRadius: "4px", padding: "2px 8px" }}>
            {typeLabel}
          </span>
        )}
        {(property.listing_url || property.streeteasy_url) && (
          <a href={property.listing_url || property.streeteasy_url} target="_blank" rel="noopener noreferrer"
            title="View web listing" style={{ display: "flex", alignItems: "center", color: "#1976d2", textDecoration: "none", fontSize: "16px" }}>🔗</a>
        )}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        {property.listing_status && (
          <span style={{ fontSize: "12px", fontWeight: 700, color: "#0d47a1", background: "#e3f0ff",
                         borderRadius: "12px", padding: "4px 12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
            {property.listing_status}
          </span>
        )}
        <div style={{ textAlign: "right" }}>
          <span style={{ fontSize: "22px", fontWeight: 700, color: "#111", whiteSpace: "nowrap" }}>
            {(property.price || property.asking_price) ? `$${Number(property.price || property.asking_price).toLocaleString()}` : "—"}
          </span>
          {property.price_change != null && property.price_change !== 0 && (
            <div style={{ fontSize: "12px", fontWeight: 600, whiteSpace: "nowrap",
                          color: property.price_change < 0 ? "#dc3545" : "#28a745" }}>
              {property.price_change < 0 ? "▼" : "▲"} ${Math.abs(property.price_change).toLocaleString()}
              {property.price_change_pct != null ? ` (${property.price_change_pct > 0 ? "+" : ""}${property.price_change_pct.toFixed(1)}%)` : ""}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
